import type { FigmaIconProps } from './types';

export const IconFigmaErrorS = ({ size = 11, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.28288 5.49967C9.2827 3.41035 7.58904 1.71647 5.49967 1.71647C3.41046 1.71665 1.71665 3.41046 1.71647 5.49967C1.71647 7.58904 3.41035 9.2827 5.49967 9.28288C7.58915 9.28288 9.28288 7.58915 9.28288 5.49967ZM10.8835 5.49967C10.8835 8.47281 8.47281 10.8835 5.49967 10.8835C2.52669 10.8833 0.116862 8.4727 0.116862 5.49967C0.117038 2.5268 2.5268 0.117038 5.49967 0.116862C8.4727 0.116862 10.8833 2.52669 10.8835 5.49967Z"
      fill={color}
    />
    <path
      d="M6.30957 3.55957C6.62199 3.24715 7.12801 3.24715 7.44043 3.55957C7.75285 3.87199 7.75285 4.37801 7.44043 4.69043L4.69043 7.44043C4.37801 7.75285 3.87199 7.75285 3.55957 7.44043C3.24715 7.12801 3.24715 6.62199 3.55957 6.30957L6.30957 3.55957Z"
      fill={color}
    />
    <path
      d="M3.55957 3.55957C3.87199 3.24715 4.37801 3.24715 4.69043 3.55957L7.44043 6.30957C7.75285 6.62199 7.75285 7.12801 7.44043 7.44043C7.12801 7.75285 6.62199 7.75285 6.30957 7.44043L3.55957 4.69043C3.24715 4.37801 3.24715 3.87199 3.55957 3.55957Z"
      fill={color}
    />
  </svg>
);
